export default "__VITE_ASSET__fBBARzv9__"